import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays product social share links.
 * This component listens for variant update events and updates the social links URLs accordingly.
 * It handles social links updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductSocialLinks extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateSocialLinks);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateSocialLinks);
  }

  /**
   * Updates the social links.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateSocialLinks = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newSocialLinks = event.detail.data.html.querySelector('product-social-links .product-accordion__social-icons');
    const currentSocialLinks = this.querySelector('.product-accordion__social-icons');

    if (!newSocialLinks || !currentSocialLinks) return;

    if (currentSocialLinks.innerHTML !== newSocialLinks.innerHTML) {
      currentSocialLinks.replaceWith(newSocialLinks.cloneNode(true));
    }
  };
}

if (!customElements.get('product-social-links')) {
  customElements.define('product-social-links', ProductSocialLinks);
}
